export default __webpack_public_path__ + "static/info-32bdc88e7b69ee8c45f6946bb139196b.jpg";